module.exports = __webpack_public_path__ + "img/copier.e8109bd1.gif";